import React from "react";
import { Link } from "react-router-dom";
import { MdMenuBook } from "react-icons/md";
import PageHero from "./PageHero";

const PostgradJournal = () => {
  return (
    <div>
      <PageHero
        kicker="BU Journal"
        title="BU Postgraduate Journal"
        subtitle="A home for graduate scholarship from Benadir University — launching soon."
      />

      <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="border border-dashed border-[#5eb3d4] bg-white p-8 sm:p-12">
          <MdMenuBook className="text-[#0863AA]" size={40} />
          <h2 className="mt-4 text-2xl font-bold text-[#0a3d6b]">Coming soon</h2>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-slate-700">
            The School of Postgraduate Studies is preparing a journal home for
            graduate scholarship from Benadir University. Meanwhile, you can
            explore existing university journals and research publications.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/research/journals"
              className="bg-[#0863AA] px-6 py-3 font-semibold text-white transition hover:bg-[#0a4f86]"
            >
              Visit BU Journals
            </Link>
            <Link
              to="/research/publications"
              className="border-2 border-[#0863AA] px-6 py-3 font-semibold text-[#0863AA] transition hover:bg-white"
            >
              Research Publications
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PostgradJournal;
